import BaseViewModel, { Required } from '@/infrastructure/BaseViewModel';

export default class Role extends BaseViewModel {
    public Id: number = 0;
    public CustomerId: number | null = 0;
    @Required('Name cannot be null.')
    public Name: string = '';
    public Deleted: boolean = false;
    public DateCreated: Date = new Date();
    public DateUpdated: Date = new Date();
}
